import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  HeadFooter: true,
  headindex: 0,
  pxInterlocutionId: '',
  not_read_message: '2'
}
const getters = {
  isShow (state) {
    return state.HeadFooter
  }
}
const mutations = {
  show (state) {
    state.HeadFooter = true
  },
  hide (state) {
    state.HeadFooter = false
  }
}
const actions = {
  hide (context) {
    context.commit('hide')
  },
  show (context) {
    context.commit('show')
  }
}
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js